import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { IApplicationLink, IApplicationRoutes } from 'ops-lib';
import { IRequestId } from 'src/app/shared/domain/id.entity';
import { SupplierMakeType } from './../domain/supplier.entity';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CommonApiService {
  apiUrl = environment.commonAPI;

  constructor(
    private httpClient: HttpClient) {
  }

  getNavigationBarLinks(body: IRequestId): Observable<IApplicationLink[]> {
    return this.httpClient.post<IApplicationLink[]>(this.apiUrl + 'application/v2/navigation', body, this.getOptions());
  }

  getApplicationsRoutes(): Observable<IApplicationRoutes[]> {
    return this.httpClient.get<IApplicationRoutes[]>(this.apiUrl + 'application/routes', this.getOptions());
  }

  AddRedirectToken(redirectUrl: string): Observable<any> {
    return this.httpClient.get<any>(this.apiUrl + `${this.apiUrl}redirect?url=${redirectUrl}`, this.getOptions());
  }

  getMakesTypes(): Observable<SupplierMakeType[]> {
    return this.httpClient.get<SupplierMakeType[]>(this.apiUrl + 'v2/shop/maketypes', this.getOptions());
  }

  getKeycloakEnabled(): Observable<IKCResponse> {
    return this.httpClient.get<IKCResponse>(
      this.apiUrl + 'application/keycloak' );
  }

  private getOptions() {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    return { headers };
  }

}

export interface ISearchRequest {
  type: string;
  criteria: string;
  features: string;
  from?: Date;
  to?: Date;
}

interface IKCResponse {
  enabled: boolean;
}
